import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

export const placeDetailsQueryKey = ['placeDetails'] as const

export const usePlaceDetails = (placeId: string) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<google.maps.places.PlaceResult>({
		queryKey: [...placeDetailsQueryKey, placeId],
		queryFn: () => authFetch(`google-places/places/${placeId}`),
		enabled: !!placeId && placeId !== 'add',
	})
}
